import { adminClient } from "./admin";

// --- Suppliers ---
export const inventoryListSuppliers = async () =>
  (await adminClient().get(`/admin/suppliers`)).data;
export const inventorySaveSupplier = async (id, payload) =>
  id
    ? (await adminClient().patch(`/admin/suppliers/${id}`, payload)).data
    : (await adminClient().post(`/admin/suppliers`, payload)).data;
export const inventoryDeleteSupplier = async (id) =>
  (await adminClient().delete(`/admin/suppliers/${id}`)).data;
export const inventoryRevealSupplierPortal = async (id) =>
  (await adminClient().post(`/admin/suppliers/${id}/reveal-portal`)).data;

// --- Materials ---
export const inventoryListMaterials = async (params = {}) =>
  (await adminClient().get(`/admin/materials`, { params })).data;
export const inventoryGetMeta = async () =>
  (await adminClient().get(`/admin/materials/meta`)).data;
export const inventorySaveMaterial = async (id, payload) =>
  id
    ? (await adminClient().patch(`/admin/materials/${id}`, payload)).data
    : (await adminClient().post(`/admin/materials`, payload)).data;
export const inventoryDeleteMaterial = async (id) =>
  (await adminClient().delete(`/admin/materials/${id}`)).data;
export const inventoryAdjustStock = async (id, delta, reason) =>
  (await adminClient().post(`/admin/materials/${id}/adjust-stock`, { delta, reason })).data;
export const inventorySeedCatalog = async () =>
  (await adminClient().post(`/admin/materials/seed`)).data;

// --- Inventory Orders ---
export const inventoryListOrders = async (params = {}) =>
  (await adminClient().get(`/admin/inventory-orders`, { params })).data;
export const inventoryCreateOrder = async (payload) =>
  (await adminClient().post(`/admin/inventory-orders`, payload)).data;
export const inventoryUpdateOrder = async (id, patch) =>
  (await adminClient().patch(`/admin/inventory-orders/${id}`, patch)).data;
export const inventoryDeleteOrder = async (id) =>
  (await adminClient().delete(`/admin/inventory-orders/${id}`)).data;

// Per-category color codes — used in Materials & Job Ticket
export const MATERIAL_CATEGORY_COLORS = {
  "Cut Sheet Paper":      { bg: "#DBEAFE", fg: "#1E3A8A", border: "#3B82F6" },
  "Wide Format Media":    { bg: "#FEF3C7", fg: "#78350F", border: "#F59E0B" },
  "Bond Paper":           { bg: "#FDE68A", fg: "#78350F", border: "#D97706" },
  "Substrates":           { bg: "#E0E7FF", fg: "#312E81", border: "#6366F1" },
  "Sign Hardware":        { bg: "#D1FAE5", fg: "#064E3B", border: "#10B981" },
  "Lamination Rolls":     { bg: "#FCE7F3", fg: "#831843", border: "#EC4899" },
  "Lamination Pouches":   { bg: "#F3E8FF", fg: "#581C87", border: "#A855F7" },
  "Binding":              { bg: "#FEE2E2", fg: "#991B1B", border: "#DC2626" },
  "Inks and PrintHeads":  { bg: "#1F2937", fg: "#FBBF24", border: "#FBBF24" },
  "Shipping Supplies":    { bg: "#FED7AA", fg: "#7C2D12", border: "#EA580C" },
  "UPS Branded Supplies": { bg: "#FFB500", fg: "#1C1917", border: "#92400E" },
  "Decorative Mailers":   { bg: "#FBCFE8", fg: "#9D174D", border: "#DB2777" },
  "Consumables":          { bg: "#CFFAFE", fg: "#155E75", border: "#06B6D4" },
  "Other":                { bg: "#E7E5E4", fg: "#1C1917", border: "#A8A29E" },
};

export const ORDER_STATUS_COLORS = {
  Placed:    { bg: "#FEF3C7", fg: "#92400E", border: "#F59E0B" },
  Received:  { bg: "#DCFCE7", fg: "#166534", border: "#16A34A" },
  Cancelled: { bg: "#FEE2E2", fg: "#991B1B", border: "#DC2626" },
};
